/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TimeOfDay,
    TimeOfDayFromJSON,
    TimeOfDayFromJSONTyped,
    TimeOfDayToJSON,
} from './';

/**
 * 
 * @export
 * @interface TimeOfDayRange
 */
export interface TimeOfDayRange {
    /**
     * 
     * @type {TimeOfDay}
     * @memberof TimeOfDayRange
     */
    from?: TimeOfDay;
    /**
     * 
     * @type {TimeOfDay}
     * @memberof TimeOfDayRange
     */
    to?: TimeOfDay;
}

export function TimeOfDayRangeFromJSON(json: any): TimeOfDayRange {
    return TimeOfDayRangeFromJSONTyped(json, false);
}

export function TimeOfDayRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeOfDayRange {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': !exists(json, 'from') ? undefined : TimeOfDayFromJSON(json['from']),
        'to': !exists(json, 'to') ? undefined : TimeOfDayFromJSON(json['to']),
    };
}

export function TimeOfDayRangeToJSON(value?: TimeOfDayRange | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': TimeOfDayToJSON(value.from),
        'to': TimeOfDayToJSON(value.to),
    };
}


